var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mdc-notched-outline",
      class: { "mdc-notched-outline--notched": _vm.preFilled }
    },
    [
      _c("div", { staticClass: "mdc-notched-outline__leading" }),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-notched-outline__notch" }, [
        _c(
          "label",
          {
            staticClass: "mdc-floating-label",
            class: { "mdc-floating-label--float-above": _vm.preFilled },
            attrs: { for: _vm.id }
          },
          [_vm._v(_vm._s(_vm.label))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-notched-outline__trailing" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }